import React from "react";
import {
  Grid,
  Card,
  Typography,
  Avatar,
  Button,
  useMediaQuery,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import ReactPlayer from "react-player";
import formatMoney from "../../utils/formatMoney";
import { Link as RouterLink, useHistory } from "react-router-dom";
import "./ReactPlayer.css";
import DateRangeIcon from "@mui/icons-material/DateRange";
import SearchIcon from "@mui/icons-material/Search";
import { Cloudinary } from "@cloudinary/url-gen";
import { useConfirm } from "material-ui-confirm";
import { MenuBook } from "@mui/icons-material";
import { Rating } from "@mui/material";
import { useSelector } from "react-redux";
import styled from "@emotion/styled";

const StyledAvatar = styled(Avatar)({
  marginBottom: "1em",
  width: "100px",
  height: "100px",
});

const ReactPlayerWrapper = styled("div")({
  position: "relative",
  paddingTop: "56.25%" /* Player ratio: 100 / (1280 / 720) */,
});

const StyledReactPlayer = styled(ReactPlayer)({
  position: "absolute",
  top: 0,
  left: 0,
});

const TeacherInfo2 = ({ teacher }) => {
  const { profile } = teacher;
  const theme = useTheme();

  const { profile: profileStudent } = useSelector(
    (state) => state.profileStudent
  );

  const matchesSM = useMediaQuery(theme.breakpoints.up("sm"));
  const matchesLG = useMediaQuery(theme.breakpoints.up("lg"));

  const history = useHistory();

  const confirm = useConfirm();

  const cld = new Cloudinary({
    cloud: {
      cloudName: "youspeak",
    },
  });

  let cldVideo;
  let cldThumbnail;
  if (profile && profile.video) {
    const cldRes = cld.video(profile.video);

    cldVideo = cldRes.toURL();

    cldThumbnail = cldVideo.split("?")[0];
    cldThumbnail = cldThumbnail + ".jpg";
  }

  let cldTeacherAvatar;
  if (profile && profile.teacherAvatar) {
    const cldRes = cld.image(profile.teacherAvatar);

    cldTeacherAvatar = cldRes.toURL();
  }

  const handleClickScheduleLesson = (teacherId) => {
    if (!profileStudent) {
      confirm({
        title:
          "Bạn chưa điền thông tin cá nhân. Vui lòng điền thông tin cá nhân trước khi đặt lịch học. Nhấn OK để đến trang điền thông tin cá nhân",
      })
        .then(() => {
          history.push(`/create-profile`);
        })
        .catch(() => { });
    } else {
      history.push(`/book-learning-time/${teacherId}`);
    }
  };

  return (
    <Card
      style={{
        margin: "0 auto 3em",
        maxWidth: matchesLG ? "60%" : matchesSM ? "70%" : undefined,
      }}
    >
      <Grid
        container
        justifyContent="center"
        alignItems="center"
        direction="column"
      >
        <Grid item style={{ width: "100%" }}>
          {cldVideo && cldThumbnail && (
            <ReactPlayerWrapper>
              <StyledReactPlayer
                url={cldVideo}
                controls
                playing
                light={cldThumbnail}
                width="100%"
                height="100%"
              />
            </ReactPlayerWrapper>
          )}
        </Grid>

        <Grid
          item
          container
          justifyContent="space-around"
          alignItems="center"
          style={{ padding: "2em 2em" }}
        >
          <Grid item>
            <Grid container direction="column" alignItems="center" spacing={2}>
              <Grid item>
                {cldTeacherAvatar && (
                  <StyledAvatar alt="teacher-avatar" src={cldTeacherAvatar} />
                )}
              </Grid>
              {teacher.typesOfLesson.length > 0 && (
                <Grid item>
                  <Button
                    onClick={() => handleClickScheduleLesson(teacher._id)}
                    variant="contained"
                    disableRipple
                    color="primary"
                    style={{
                      color: "white",
                      textTransform: "uppercase",
                      fontWeight: "600",
                      background: "#b30000",
                    }}
                  >
                    <Grid container justifyContent="center" alignItems="center">
                      <Grid item>
                        <DateRangeIcon />
                        &nbsp;
                      </Grid>
                      <Grid item>Đặt lịch học</Grid>
                    </Grid>
                  </Button>
                </Grid>
              )}

              <Grid item>
                {teacher && (
                  <Button
                    component={RouterLink}
                    to={`/teachers/${teacher._id}`}
                    variant="contained"
                    disableRipple
                    color="primary"
                    style={{
                      color: "white",
                      textTransform: "uppercase",
                      fontWeight: "600",
                    }}
                  >
                    <Grid container justifyContent="center" alignItems="center">
                      <Grid item>
                        <SearchIcon />
                        &nbsp;
                      </Grid>
                      <Grid item>Xem thêm về giáo viên</Grid>
                    </Grid>
                  </Button>
                )}
              </Grid>
            </Grid>
          </Grid>

          <Grid item>
            <Grid
              container
              direction="column"
              justifyContent="center"
              spacing={1}
            >
              <Grid item>
                {teacher && teacher.name && (
                  <Typography variant="h5" style={{ fontWeight: 600 }}>
                    {teacher.name}
                  </Typography>
                )}
              </Grid>

              <Grid item>
                <Typography variant="h6">
                  {teacher &&
                    teacher.profile &&
                    teacher.profile.typeOfTeacher === "professional"
                    ? "Giáo viên chuyên nghiệp"
                    : "Giáo viên cộng đồng"}
                </Typography>
              </Grid>

              <Grid item>
                <Typography variant="body1">
                  <Grid container alignItems="center">
                    <Grid item>
                      <Rating
                        value={teacher.averageRating}
                        precision={0.5}
                        readOnly
                      />
                    </Grid>

                    <Grid item>
                      ( Có{" "}
                      <strong>
                        {teacher &&
                          teacher.profile &&
                          teacher.profile.reviews &&
                          teacher.profile.reviews.length}
                      </strong>{" "}
                      đánh giá )
                    </Grid>
                  </Grid>
                </Typography>
              </Grid>

              {/* <Grid item>
                <Typography variant="body1">
                  <Grid container alignItems="center">
                    <Grid item>
                      <MenuBook />
                      &nbsp;
                    </Grid>

                     <Grid item>
                      Đã dạy{" "}
                      <strong>
                        {teacher && teacher.succeededBookedLessons.length}
                      </strong>{" "}
                      bài học
                    </Grid>
                  </Grid>
                </Typography>
              </Grid> */}
            </Grid>
          </Grid>
          <Grid item>
            <Grid
              container
              direction="column"
              justifyContent="center"
              spacing={2}
            >
              <Grid item container direction="column">
                <Grid item>
                  <Typography variant="h6">Đến từ:</Typography>
                </Grid>

                <Grid item>
                  <Typography variant="body1">
                    &nbsp;
                    {teacher &&
                      teacher.profile &&
                      teacher.profile.hometown &&
                      teacher.profile.hometown.label}
                  </Typography>
                </Grid>
              </Grid>

              <Grid item container direction="column">
                {teacher &&
                  teacher.profile &&
                  teacher.profile.lessons &&
                  teacher.profile.lessons.length > 0 && (
                    <>
                      <Grid item>
                        <Typography variant="h6">Học phí từ:</Typography>
                      </Grid>

                      <Grid item>
                        <Typography variant="body1">
                          {formatMoney(teacher.minPriceOfTypesOfLesson)}
                          &nbsp;VNĐ
                        </Typography>
                      </Grid>
                    </>
                  )}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Card>
  );
};

export default TeacherInfo2;
